import http from 'plugins/axios';

export default {
  getUserOrderLogList(data) {
    return http.get({
      url: '/la/admin/user/userOrderLog',
      data,
    });
  },
};
